import { render, staticRenderFns } from "./my-cases.vue?vue&type=template&id=665afa81"
import script from "./my-cases.vue?vue&type=script&lang=js"
export * from "./my-cases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports